module.exports = __webpack_public_path__ + "img/1.59862f39.svg";